
export default _ => (dispatch, getState) => {
  const {search, preSearch} = getState().completedTours
  const isTourCompleted = search || preSearch
  const newValue = !isTourCompleted
  localStorage.setItem("search-tour-completed", newValue)
  localStorage.setItem("pre-search-tour-completed", newValue)
  dispatch({type: 'save_completed_tours', completedTours: {search: newValue, preSearch: newValue}})
}



/** WEBPACK FOOTER **
 ** ./app/actions/toggleTour.js
 **/